module.exports = __webpack_public_path__ + "assets/img/patient-man-active-icon.20cbc976.png";